import React from "react";
import Lottie from "lottie-react";
import BlueSpinner from "../visuals/SpinnerAnimation.json";
import WhiteSpinner from "../visuals/LoadingSpinnerWhite.json";

const DEFAULT_SIZE = 50;

type LoadingSpinnerProps = {
  classname?: string;
  size?: number;
  color?: "white" | "blue";
};

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  classname,
  size,
  color = "blue",
}) => {
  const loadingAnimation = () => {
    switch (color) {
      case "white":
        return WhiteSpinner;
      case "blue":
        return BlueSpinner;

      default:
        return BlueSpinner;
    }
  };

  return (
    <Lottie
      animationData={loadingAnimation()}
      className={classname || ""}
      style={{ height: size || DEFAULT_SIZE }}
      id="LoadingSpinner"
      color="#ffffff"
    />
  );
};

export default LoadingSpinner;
